import { useNavigate } from 'react-router'
import { MainContent } from '../components/MainContent'
import { Recap } from './chaloupka/Recap'

export const MeetingRecordSme = () => {
  const navigate = useNavigate()

  return (
    <MainContent>
      <Recap />
    </MainContent>
  )
}
